import React from "react";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import CheckboxQues from "./checkbox";

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "-webkit-fill-available",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
});

class Registration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionlist: [],
      isLoading: false,
      showSlider: true,
      temp: false,
      animCssClasses: 'animate__animated animate__zoomIn animate__faster',
      value: ''
    };
    this.inputChangevent = this.inputChangevent.bind(this)
  }

  componentDidMount() {
    //console.log(this.props.question)
    // console.log("componentDidMount>", this.props);
    // setTimeout(() => {
    //   this.setState({
    //     showSlider: this.props.showSlider
    //   })
    // }, 1000);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.values != this.props.values) {
      this.setState({ value: this.props.values })
    }
  }

  // shouldComponentUpdate(nextPorps) {
  //   if (this.props.showSlider !== nextPorps.showSlider) {
  //     console.log("shouldComponentUpdate slider>>", nextPorps.showSlider, this.props.showSlider, nextPorps.animCssClasses);
  //     this.setState({
  //       animCssClasses: nextPorps.animCssClasses,
  //     });
  //     return true;
  //   }
  //   return false;
  // }

  static getDerivedStateFromProps(nextProps) {
    return {
      animCssClasses: nextProps.animCssClasses,
      showSlider: nextProps.showSlider
    }
  }


  renderQuestion() {
    var element = this.props.question;
    const { templateID } = this.props;
    var quslist = [];
    return (
      <div id={element.questionId}>
        <p className={templateID == 1 ? "text-left fw-500" : ""}>{element.question}</p>
        <FormControl component="fieldset">
          {this.getQuestionType(element)}
        </FormControl>
      </div>
    );
  }

  getQuestionType(element) {
    switch (element.type.toLowerCase()) {
      case "number":
        return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "datetime":
        return this.getTimeType(element);
      case "freetext":
        return this.getTextType(element);
      case "text":
        return this.getTextType(element);
      case "dropdown":
        return this.getRadioType(element);
      case "radio":
        return this.getRadioType(element);
      case "checkbox":
        return this.getCheckboxType(element);
    }
  }

  inputChangevent(id, evt) {
    this.setState({ value: evt.target.value })
    this.props.updateCompletionPer(id, evt.target.value, evt.target.type);
  }


  getTextType(element) {
    let name = element.name.toLowerCase()
    let maxLength = name == 'age' ? 3 : (name == 'phone number' ? 10 : 1000);
    let type = name == 'age' ? 'number' : (name == 'phone number' ? 'number' : 'text')
    return (
      <TextField
        type={'text'}
        value={element.value}
        name={element.questionId}
        inputProps={{ maxLength: maxLength }}
        onBlur={(evt) => this.inputChangevent(element.questionId, evt)}
      />
    );
  }

  getDateType(element) {
    return (
      <TextField
        type="date"
        value={element.value}
        name={element.questionId}
        onBlur={(evt) => this.inputChangevent(element.questionId, evt)}
      />
    );
  }

  getTimeType(element) {
    return (
      <TextField
        type="time"
        value={element.value}
        name={element.questionId}
        onBlur={(evt) => this.inputChangevent(element.questionId, evt)}
      />
    );
  }


  getRadioType(element) {
    var radiobuttons = [];
    Object.entries(element.optionMap).forEach(entry => {
      const [key, value] = entry;
      radiobuttons.push(
        <FormControlLabel
          key={key}
          id={key}
          value={key}
          control={<Radio name={element.questionId} />}
          label={value}
          onClick={(evt) => this.inputChangevent(element.questionId, evt)}
        />
      );
    })
    return <RadioGroup value={this.state.value} name={element.name}>{radiobuttons}</RadioGroup>;
  }

  getCheckboxType(element) {
    var radiobuttons = [];
    Object.entries(element.optionMap).forEach(entry => {
      const [key, value] = entry;
      let checked = element.response && element.response.includes(key) ? true : false;
      radiobuttons.push(
        <CheckboxQues
          key={key}
          value={key}
          checkedFalg={checked}
          name={element.questionId}
          label={value}
          element={element}
          inputChangevent={this.inputChangevent}
        >
        </CheckboxQues>
        // <FormControlLabel
        // checked={checked}
        //   key={key}
        //   id={key}
        //   value={key}
        //   control={<Checkbox name={element.questionId} />}
        //   label={value}
        //   onClick={(evt) => this.inputChangevent(element.questionId, evt)}
        // />
      );
    })
    return <FormGroup>{radiobuttons}</FormGroup>;
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;
    if (this.props.question) {
      return (
        <>
          {/* {JSON.stringify(this.props.showSlider)} */}
          {this.renderQuestion()}
        </>
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
  };
}

export default withStyles(useStyles)(connect(mapStateToProps, { })(withTranslation()(Registration)))
//export default withStyles(useStyles)(withTranslation()(Registration));
